import React from 'react';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { useModal } from '@common/react/components/Modal/ModalContextProvider';
import { ConfirmPhoneCodeModal } from '@common/react/components/UI/ChangePhoneModal/ChangePhoneModal';

import { User } from '@app/objects/User';

const DashboardTopAlert: React.FC = () => {
	const { getUser, request, updateUser } = useApplicationContext();
	const user = getUser<User>();
	const { openErrorMessage, openSuccessMessage } = useModal();
	const showAlert = user && !user?.emailConfirmed && !user?.phoneNumberConfirmed;
	const [visibleConfirm, setVisibleConfirm] = React.useState<boolean>(false);
	if (!showAlert) {
		return null;
	}
	const isEmail = user.email && !user.emailConfirmed;
	const handleClick = () => {
		if (isEmail) {
			request('sendConfirmEmail', {})
				.then(() => openSuccessMessage?.('The activation email has been successfully sent.'))
				.catch((err) => openErrorMessage?.(err));
		} else {
			request('sendPhoneConfirmationCode', {})
				.then(() => setVisibleConfirm(true))
				.catch((err) => openErrorMessage?.(err));
		}
	};

	return <div className="dashboard-top-alert__wrapper">
		<div className="dashboard-top-alert alert alert-danger">
			This account is not confirmed.&nbsp;Please
			{' '}
			<a onClick={handleClick}>click here</a>
			{' '}
			to
			{isEmail ? ' resend the confirmation email.' : ' send code to confirm your phone number.'}
		</div>
		<ConfirmPhoneCodeModal
			visibleConfirm={visibleConfirm}
			phoneNumber={user.phoneNumber}
			savedPhoneNumber={user.phoneNumber}
			setVisibleConfirm={setVisibleConfirm}
			afterSubmit={() => {
				updateUser({ phoneNumberConfirmed: true });
				openSuccessMessage?.('Your phone number successfully confirmed.');
			}}
		/>
	</div>;
};

export default DashboardTopAlert;
